exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".offline-badge[data-v-78af7a8a]{bottom:0;left:0;right:0;z-index:3}\n", ""]);

// exports
